import {
  USER_LOADING,
  USER_LOADING_OPERATION,
  USER_END_LOADING,
  USER_END_LOADING_OPERATION,
  USER_GET_DATA,
  USER_ADD_SINGLE,
  USER_UPDATE_SINGLE,
  USER_REMOVE_SINGLE,
  USER_GET_SINGLE,
  USER_CLEAR,
} from "../redux/types";

import * as api from "./api";

/**
 * Obtiene todos los usuarios
 */
export const getUsers =
  (data = null, callbackFN = null) =>
  async (dispatch) => {
    const response = await api.get(dispatch, {
      url: "/users/get",
      loadingType: USER_LOADING,
      successType: USER_GET_DATA,
      errorType: USER_END_LOADING,
      data,
    });
    if (callbackFN && response) callbackFN(response.success || false);
  };

export const createUser =
  (data = null, callbackFN = null) =>
  async (dispatch) => {
    const response = await api.post(dispatch, {
      url: "/users/create",
      loadingType: USER_LOADING_OPERATION,
      successType: USER_ADD_SINGLE,
      errorType: USER_END_LOADING_OPERATION,
      data,
    });
    if (callbackFN && response) callbackFN(response.success || false);
  };

export const updateUser =
  (data = null, callbackFN = null) =>
  async (dispatch) => {
    const response = await api.post(dispatch, {
      url: "/users/update",
      loadingType: USER_LOADING_OPERATION,
      successType: USER_UPDATE_SINGLE,
      errorType: USER_END_LOADING_OPERATION,
      data,
    });
    if (callbackFN && response) callbackFN(response.success || false);
  };

export const deleteUser =
  (id = null, callbackFN = null) =>
  async (dispatch) => {
    const response = await api.deletefn(dispatch, {
      url: `/users/delete/${id}`,
      loadingType: USER_LOADING_OPERATION,
      successType: USER_REMOVE_SINGLE,
      errorType: USER_END_LOADING_OPERATION,
      successPayload: { id },
    });
    if (callbackFN && response) callbackFN(response.success || false);
  };

export const setEditUserFromFunction = (user) => (dispatch) => {
  dispatch({
    type: USER_GET_SINGLE,
    payload: user,
  });
};
